import React from 'react'
import { Button } from '@shared/components/button'
import { scrollToLoanForm } from '@shared/components/forms/new-loan'
import { Section } from '@shared/components/section'

import { getLoanEasySteps } from './data'

import styles from './style.module.scss'

export const View = ({ title }: { title: string }) => (
	<Section className={styles.fluidWrapper} fullWidth>
		<Section className={styles.wrapper}>
			<div className={styles.titleWrap}>
				<h2 className={styles.title}>{title}</h2>
			</div>
			<div className={styles.steps}>
				{getLoanEasySteps.map(({ title, content }) => (
					<div key={title} className={styles.step}>
						<h4>{title}</h4>
						<h5 className={styles.stepContent}>{content}</h5>
					</div>
				))}
				<Button className={styles.button} onClick={scrollToLoanForm}>
					Подать заявку
				</Button>
			</div>
		</Section>
	</Section>
)
